const _ = require("lodash")

module.exports = label =>
  _(label)
    .kebabCase()
    .toLowerCase()
